import React, { useState, useEffect } from "react";
import db from "../../firebase";  
import { useParams, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import Divider from '@material-ui/core/Divider';

const EditBlog = () => {
    let history = useHistory();
    const { blogTitle } = useParams();
    const [docId , setDocId ] = useState("");
    // Set initial values of the fields
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [featuredImg, setFeaturedImg] = useState("");
    const [article, setArticle] = useState("");
    // Get the blog by matching the title
    // useEffect is used here to stop loading database on every render, it'll load only once, when the page loads
    useEffect (() => {
        db.collection("blogs").where("title", "==", blogTitle).get().then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
                let post = {};
                post = doc.data();
                setTitle(post.title);
                setDescription(post.description);
                setFeaturedImg(post.featuredImg);
                setArticle(post.article);
                setDocId(querySnapshot.docs[0].id);
            })
        })
    }, [ blogTitle ])
    // const [instaLink, setInstaLink] = useState("");
    // const [instaArray, setInstaArray] = useState([]);
    // const handleMoreLink = (event) => {
    //     setInstaArray(prevItems => ([...prevItems, instaLink]));
    // }
    const handleSubmit = async(event) => {
        event.preventDefault();
        const blog = { 
            title: title, 
            description: description, 
            featuredImg: featuredImg, 
            article: article,
        };
        await db.collection("blogs").doc(docId).update(blog);
        console.log("data updated");
        history.push("/admin/posts");
    }

    return (
        <Grid>
            <h1>Edit Post page</h1>
            {/* Edit the Post */}
            <form className="container" onSubmit={handleSubmit}>
                {/* Title */}
                <TextField 
                    fullWidth id="Title"
                    label="Title" 
                    variant="filled" 
                    value={title} 
                    onChange={(event) => setTitle(event.target.value)} 
                    helperText="Enter the Title of the post"
                />
                {/* Description */}
                <TextField
                    fullWidth
                    id="Description"
                    label="Description"
                    variant="filled"
                    value={description}
                    onChange={(event) => (setDescription(event.target.value))}
                    helperText="Enter the Description of the post"
                />
                {/* Featured Image */}
                <TextField fullWidth id="featuredImg" label="Featured Image" variant="filled" value={featuredImg} onChange={(event) => setFeaturedImg(event.target.value)} helperText="Enter the link of the image" />
                <img src= {featuredImg} alt="" />
                {/* Article */}
                <TextField multiline fullWidth id="filled-basic" label="Article" variant="filled" value={article} onChange={(event) => setArticle(event.target.value)} rows={50} helperText="Enter the post in html format (without the <head> and <body> tags, just the <p> <img> and other tags)" />
                {/* Insta post Carousel images */}
                {/* <TextField fullWidth id="featuredImg" label="Carousel Image link" variant="filled" value={instaLink} onChange={(event) => setInstaLink(event.target.value)} helperText="Enter the link of the Instagram post image" />
                <Button type="button" color="primary" variant="outlined" onClick={handleMoreLink}>Add more</Button>
                <Grid container direction="row" spacing={1}>
                    {instaArray.map((instaImg, i) => (
                        <Grid item key={i}>
                            <img className="EditBlogInstaImg" key={instaImg} src={instaImg} alt="" />
                        </Grid>))
                    }
                </Grid> */}
                {/* Submit button */}
                <Divider />
                <Button type="submit" endIcon={<SendIcon />} variant="outlined">
                    Update
                </Button>
            </form>
        </Grid>
    );
}

export default EditBlog;